import React from 'react';
import { Sparkles, Image as ImageIcon } from 'lucide-react';
import { PageSection } from '../../../../types';
import { ActionLinkInput } from '../common/ActionLinkInput';

interface CustomContentEditorProps {
  section: PageSection;
  onUpdateContent: (updates: any) => void;
}

export const CustomContentEditor: React.FC<CustomContentEditorProps> = ({ section, onUpdateContent }) => {
  const content = section.content || {};

  return (
    <div className="space-y-6">
      <div className="p-4 rounded-2xl bg-slate-800/40 border border-slate-700/60 space-y-3.5">
        <div className="flex items-center gap-2">
          <Sparkles className="w-3.5 h-3.5 text-blue-400" />
          <h4 className="text-xs font-bold text-slate-200">İçerik Metinleri</h4>
        </div>

        <div className="space-y-1">
          <label className="text-[10px] font-bold uppercase tracking-wider text-slate-400">Üst Rozet (Badge)</label>
          <input
            type="text"
            value={content.badge ?? ''}
            onChange={(e) => onUpdateContent({ badge: e.target.value })}
            placeholder="Örn: ÖZEL BÖLÜM"
            className="w-full bg-slate-900 border border-slate-700 text-xs font-semibold text-slate-200 px-3 py-2 rounded-xl outline-none focus:border-blue-500"
          />
        </div>

        <div className="space-y-1">
          <label className="text-[10px] font-bold uppercase tracking-wider text-slate-400">Ana Başlık</label>
          <input
            type="text"
            value={content.title ?? ''}
            onChange={(e) => onUpdateContent({ title: e.target.value })}
            placeholder="Bölüm başlığı..."
            className="w-full bg-slate-900 border border-slate-700 text-xs font-bold text-slate-100 px-3 py-2 rounded-xl outline-none focus:border-blue-500"
          />
        </div>

        <div className="space-y-1">
          <label className="text-[10px] font-bold uppercase tracking-wider text-slate-400">Açıklama / Gövde Metni</label>
          <textarea
            value={content.description ?? ''}
            onChange={(e) => onUpdateContent({ description: e.target.value })}
            rows={4}
            placeholder="Detaylı metin içeriği..."
            className="w-full bg-slate-900 border border-slate-700 text-xs text-slate-200 p-2.5 rounded-xl outline-none focus:border-blue-500 resize-none"
          />
        </div>

        <div className="space-y-1">
          <label className="text-[10px] font-bold uppercase tracking-wider text-slate-400">Görsel URL (Opsiyonel)</label>
          <input
            type="url"
            value={content.imageUrl ?? ''}
            onChange={(e) => onUpdateContent({ imageUrl: e.target.value })}
            placeholder="https://images.unsplash.com/..."
            className="w-full bg-slate-900 border border-slate-700 text-xs text-slate-200 px-3 py-2 rounded-xl outline-none focus:border-blue-500"
          />
        </div>
      </div>

      <ActionLinkInput
        label="Eylem Butonu"
        buttonText={content.buttonText ?? 'Detaylı İncele'}
        onButtonTextChange={(txt) => onUpdateContent({ buttonText: txt })}
        linkType={content.buttonLinkType || 'page'}
        onLinkTypeChange={(type) => onUpdateContent({ buttonLinkType: type })}
        linkValue={content.buttonLink || '/iletisim'}
        onLinkValueChange={(val) => onUpdateContent({ buttonLink: val })}
      />
    </div>
  );
};
